import { Typography, Grid } from '@mui/material'
import { IApiIssue, ApiUserFilter, userService } from '@tap/data-providers';
import { GridColDef } from '@mui/x-data-grid-pro';
import { IComponentCss } from '@tap/mui-ui';
import { memo } from 'react';
import { ruRU } from '@mui/x-date-pickers/locales';

/*
*   Текущие фильтры
*/

type CurrentFiltersBlockProps = {
    userFilter: ApiUserFilter,
    columns: GridColDef<IApiIssue, any, any>[],
}


const css: IComponentCss = {
    wrap: {
        marginTop: '10px',
    },
    title: {
        marginBottom: '5px',
    },
    list: {
        paddingLeft: '16px',
    },
    noFilters: {
        marginLeft: '-16px',
    },
    filterItem: {
        display: 'list-item',
        listStyleType: 'disc',
    },
}

type IFilterItem = {
    columnName: string | number,
    operator: string,
    value: string | number,
}


const FilterItem = memo(({
    columnName,
    operator,
    value,
}: IFilterItem) => {
    return (
        <Typography sx={css.filterItem}>
            {columnName}
            <strong>{` ${operator} `}</strong>
            {value}
        </Typography>
    )
}, (prevProps, nextProps) => {
    return prevProps.columnName === nextProps.columnName
        && prevProps.operator === nextProps.operator
        && prevProps.value === nextProps.value;
});


export default function CurrentFiltersBlock({
    userFilter,
    columns,
}: CurrentFiltersBlockProps) {

    const dataGridTranslate = ruRU.components.MuiLocalizationProvider.defaultProps.localeText;
    const filterItems = userFilter.settings?.filterModel.items || [];

    const getCurrentFilterParams = (f: any) => {
        const filterOperatorConst = `filterOperator${f.operator[0].toUpperCase() + f.operator.slice(1)}`;

        const column = columns?.find(c => c.field === f.column) ?? { headerName: f.column };
        const operator = dataGridTranslate[filterOperatorConst] ?? f.operator
        let value = undefined;

        if (column?.field === 'createdBy') {
            value = f?.value?.lastName
                ? userService.getUserFIO(f?.value)
                : '—'
        } else if (Array.isArray(f?.value)) {
            value = column?.valueOptions
                ? f.value.map((fv: string) => column?.valueOptions.find((vo: any) => vo.value === fv).label).join(', ')
                : f.value.join(', ');
        } else {
            value = column?.valueOptions
                ? column?.valueOptions.find(v => v?.value === f?.value)?.label ?? f.value
                : f.value
        }

        return [column, operator, value];
    }

    return (
        <Grid sx={css.wrap}>
            <Typography sx={css.title}>Параметры фильтра:</Typography>
            <Grid sx={css.list}>

                {(filterItems.length === 0)
                    && <Typography sx={css.noFilters}>Не заданы</Typography>
                }

                {filterItems.length > 0 && filterItems.map((filter: any, i: number) => {
                    const [column, operator, value] = getCurrentFilterParams(filter);
                    if (!value) return null;

                    return <FilterItem
                        key={i}
                        columnName={column.headerName}
                        operator={operator}
                        value={value}
                    />
                })}
            </Grid>
        </Grid>
    )
}
